const convertToMinutes = (time12h: string): number => {
    const [time, modifier] = time12h.split(' ');
    const [hoursStr, minutes] = time.split(':');
    let hours = parseInt(hoursStr, 10);

    if (modifier?.toLowerCase() === 'pm' && hours !== 12) {
        hours += 12;
    }
    if (modifier?.toLowerCase() === 'am' && hours === 12) {
        hours = 0;
    }

    return Number(hours) * 60 + Number(minutes);
};
const getMinutesSinceStartOfDay = () => {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    return hours * 60 + minutes;
};

export const checkIsRestaurantOpen = (openingHour: string, closingHour: string) => {
    const openingTimeMinutes = convertToMinutes(openingHour);
    const closingTimeMinutes = convertToMinutes(closingHour);
    const currentMinutes = getMinutesSinceStartOfDay();

    if (openingTimeMinutes < closingTimeMinutes) {
        // Normal same-day hours, e.g., 9 AM to 5 PM
        return currentMinutes >= openingTimeMinutes && currentMinutes <= closingTimeMinutes;
    }

    // Overnight hours, e.g., 11 AM to 3 AM
    return currentMinutes >= openingTimeMinutes || currentMinutes <= closingTimeMinutes;
};
